import React, { Component } from 'react'
import './Overview.scss'

class Overview extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        return (
            <div className='overview'>
              <div className='panel'>
                <div className='panel-heading hidden'>
                  Overview
                </div>
                <div className='text-center panel-body' style={{paddingTop: 20, paddingBottom: 20}}>
                  <h3 className='m-0'>£{Number(this.props.profit).toFixed(2)}<br/><small className='text-muted'>Profit</small></h3>
                </div>
                <div className="half-half">
                    <div><strong>£{Number(this.props.cost).toFixed(2)}</strong><br/><small className='text-muted'>Cost</small></div>
                    <div><strong>£{Number(this.props.sale).toFixed(2)}</strong><br/><small className='text-muted'>Sale</small></div>
                </div>
              </div>
            </div>
        )
    }
}

export default Overview



// WEBPACK FOOTER //
// ./src/views/components/Overview/index.js